import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { ecomThunk } from 'redux/slices/ecoms-slice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { BootstrapHandler } from '../../utils/bootstrapHandler';
import EventHandler from './EventHandler';
import DefaultImageSkeleton from './skeletons/static-image-skeletons/DefaultImageSkeleton';

export default function BootstrapRouteWrapper() {
    const ecoms = useAppSelector((state) => state.ecoms);
    const settings = useAppSelector((state) => state.settings);
    const wizardState = useAppSelector((state) => state.wizard);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!ecoms?.selected) {
            dispatch(ecomThunk());
        }
    }, []);

    if (!ecoms?.selected) {
        return (
            <>
                <DefaultImageSkeleton />
            </>
        );
    }

    if (!settings.settings || wizardState.fetching) {
        return (
            <>
                <BootstrapHandler />
                <DefaultImageSkeleton />
            </>
        );
    }

    return (
        <>
            <BootstrapHandler />
            <EventHandler />
            <Outlet />
        </>
    );
}
